// import { Modal } from 'antd';
import { IconProps } from '@phosphor-icons/react';
import * as PhosphorIcons from '@phosphor-icons/react';
import React, { useState } from 'react';
import { Button, Typography } from 'tfc-components';

import IconCom from 'components/atoms/Icon';
import ModalCustom from 'components/organisms/Modal';

interface ActionIconListProps {
  open: boolean;
  onCancel: () => void;
  onSave?: (iconName: string) => void
}

interface DynamicIconProps extends IconProps {
  name: string;
}

export const DynamicIcon: React.FC<DynamicIconProps> = ({ name, ...props }) => {
  const IconComponent = ((PhosphorIcons as unknown) as Record<string, React.FC<IconProps>>)[name];
  return <IconComponent {...props} />;
};
const iconList = Object.keys(PhosphorIcons).filter((name) => name !== 'SSR' && !name.toLowerCase().includes('icon'));
// const iconantdList = Object.keys(Icons).slice(0, 831);

const ActionIconList: React.FC<ActionIconListProps> = ({ open, onCancel, onSave }) => {
  const [iconSelected, setIconSelected] = useState<string>('');
  return (
    <ModalCustom width={860} isOpen={open} className="o-actionIcon">
      {/* Header */}
      <div className="o-actionIcon_header">
        <div className="">
          <Typography.Text fontweight="600">Change AI action icon</Typography.Text>
          <Typography.Text extendClasses="o-actionIcon_subtitle">Select the icon you want to use.</Typography.Text>
        </div>
        <Button onClick={onCancel}>
          <IconCom iconName="grayClose" size="20" />
        </Button>
      </div>

      {/* List icon */}
      <div className="o-actionIcon_listIcon">
        {iconList.map((name) => (
          <Button onClick={() => setIconSelected(name)} extendClasses={`o-actionIcon_iconItem ${iconSelected === name && 'o-actionIcon_iconItem-active'}`} key={`icon${name}`}>
            <DynamicIcon name={name} size={24} />
            {
              name === iconSelected && (
                <>
                  <div className="o-actionIcon_triangleUp" />

                  <IconCom className="o-actionIcon_checkIcon" iconName="checkWhite" size="18" />

                </>
              )
            }
          </Button>
        ))}

      </div>

      {/* Footer */}
      <div className="o-actionIcon_footer">
        <Button onClick={onCancel} extendClasses="o-actionIcon_cannelBtn">
          Cancel
        </Button>
        <Button onClick={() => onSave && onSave(iconSelected)} extendClasses="o-actionIcon_changeBtn" variant="primary">
          Change
        </Button>
      </div>

    </ModalCustom>
  );
};

export default ActionIconList;
